import { render, staticRenderFns } from "./CellRendererActionQuestion.vue?vue&type=template&id=72df3884&scoped=true"
import script from "./CellRendererActionQuestion.vue?vue&type=script&lang=js"
export * from "./CellRendererActionQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df3884",
  null
  
)

export default component.exports